import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePaymentDateCommand extends BaseCommand {
  CommandName = "ChangePaymentDate";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
